
import 'raf/polyfill'
import 'babel-polyfill'

import React from 'react'

import { connect } from 'react-redux'

import {getInFoFn} from '../../redux/chatuser.redux.js'

import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import LoginBar from '../../component/login/login.js'
import './my-member.css'
import {userList} from '../../redux/chatuser.redux.js'
import {getLoginURL} from '../../util.js'
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
@connect(
  state=>state.chatuser,
  {getInFoFn,userList,getBigBGUrl}
)
class MyMember extends React.Component{
	constructor(props){
		super(props)
		this.state={
      		'memberAsideNum':0
    	}
    	this.memberAside=["成长体系","成长值","会员特权","Q&A"] 		
	}

	componentDidMount(){
    	this.props.getInFoFn()
    	this.pageScrollTo()  	
    
  	}
  	componentWillReceiveProps(nextProps){
  		console.log(nextProps.userlist.code)
  	}
  	pageScrollTo(){
		const num = this.props.location.pathname.substring(11)
		window.scrollTo(0,num)
  	}
  	handleScrollTo(i){
  		
  		if(i||i===0){
  			const arr = ['0','600','1300','2000']
			this.setState({
				memberAsideNum:i
			})
			window.scrollTo(0,arr[i])
			
  		}else{
  			
  			window.scrollTo(0,1300)
  		}
  		
  	}
  	render(){
  		//this.pageScrollTo()
  		this.props.userlist.code?()=>getLoginURL(this.props.location.pathname):null
  		
  		const inFoMsg = this.props.inFoMsg
  		var  loginLevel = this.props.userlist.gradeInfo?this.props.userlist.gradeInfo.vipGrade:'login-level-0'	
		var VipSystem = ''
		if(loginLevel<=1){
			loginLevel= 'member-power-grid-1'
			VipSystem='vip-system-0'
		}else if(loginLevel<=4&&loginLevel>1){
			loginLevel= 'member-power-grid-2'
			VipSystem='vip-system-1'

		}else if(loginLevel>4&&loginLevel<=7){
			loginLevel= 'member-power-grid-3'
			VipSystem='vip-system-2'
		}else if(loginLevel>=8){
			loginLevel= 'member-power-grid-4'
			VipSystem='vip-system-3'
		}
		
		return (
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>
				<HeaderBar></HeaderBar>
				<div className="my-member-box">
						<LoginBar showLogin={this.props.showLogin}>
			               
			            </LoginBar>
			         <ul className="member-aside-box">
			         {
			         	this.memberAside.map((item,i)=>{
				         	return (
				         		<li 
				         			key={i} 
				         			onClick={()=>this.handleScrollTo(i)} 
				         			className={i===this.state.memberAsideNum?'active':null
				         		}>{item}</li>
				         	)
			         	})
			         }
						
			         </ul>
					<div className="my-member-con">
						<div className="my-power my-member">
							<h6><i></i>我的会员</h6>
							
							<dl className="clearfix">

								<dt>会员等级：</dt>
								<dd>{inFoMsg.curBigVipGrade}</dd>
	
								<dt>成长值：</dt>
								<dd>{inFoMsg.curVipGrowth}</dd>
								<dt>距离升级还需：</dt>
								<dd>{inFoMsg.diffBigVipGrowth}</dd>
	
							</dl>
						</div>
						<div className="my-power my-member">
							<h6><i></i>心享俱乐部成长体系</h6>
							<div className={"vip-system "+VipSystem+""}>
								<a href="javascript:;" className="check-power"></a>
								<span onClick={()=>this.handleScrollTo()}></span>
							</div>
						</div>
						<div className="my-power">
							<h6><i></i>心享成长值</h6>
							<div className="growth-value">
								<div className="growth-name">
								<span>成长值=游戏内消费</span>
								<span sty>客户端游戏 : 消耗10点券=1点成长值</span>
								<span>手机游戏 : 充值1元=10点成长值</span>
							</div>
							</div>
							<div className="growth-con">
								<span>备注：</span>
								<p>1、通过消耗累计成长值：以认证手机为基准，其下所有通行证自2011年1月1日起在指定游戏应用内的累计消费为主要判定条件（即在指定游戏应用内消费的元宝、点券等）。成长值的最小单位为1，客户端游戏：每消耗10点券（或等值的元宝、守护点等）获得1点成长值，不足10点券不累计成长值；手机游戏（仅支持盛趣账号）：每充值1元，累计10点成长值，不产生积分；</p>
								<p>2、指定客户端游戏应用包含：传奇世界、夺宝传世、传世无双、热血传奇、传奇外传、传奇归来、传奇3、冒险岛、 泡泡堂、彩虹岛、传奇永恒、龙之谷、龙之谷怀旧服、永恒之塔、最终幻想14、新热血英豪、传世群英传、星辰变、 新英雄年代、风云、星尘传说；</p>
								<p>3、指定手机游戏应用包含：传奇新百区-盟重神兵、龙之谷世界、光明勇士、超级地城之光、血族、辐射:避难所 Online、庆余年。</p>
							</div>

						</div>
						<div className="my-power">
							<h6><i></i>会员特权</h6>
							<div className={loginLevel}></div>
							
						</div>
						<div className="my-power">
							<h6><i></i>心享俱乐部 Q&A</h6>
							
							<div className="club-QA">
								<div className="answer">Q：新绑定、解绑、更换认证手机时VIP信息怎么处理？</div>
								<div className="response">
									
									<p><strong>A:</strong>1) VIP信息包括一个手机下多个通行证累计的成长值、以及VIP等级。当发生手机绑定、解绑、更换行为时 VIP 信息会作为一个整体进行迁移。</p>
           							<p>2) 单个通行证新绑定至手机，手机的VIP信息取单个通行证和手机中成长值高的VIP信息。</p>
           							<p>3) 单个通行证从手机下解绑，如该通行证为手机下非唯一账号，则VIP信息保留在手机上，该账号的VIP信息清空； 如为手机下唯一账号，则VIP信息保留在该账号内。</p>
           							<p>4) 手机账号群更换至新手机，新手机取新老手机中成长值高的VIP信息。</p>
           							<p>5) 单个通行证更换手机，如该通行证为手机下非唯一账号，则该通行证的VIP信息以新手机为准；如该通行证为手机下唯一账号，则新手机的VIP信息取老手机和新手机中成长值高的VIP信息。</p>
								</div>
								<p>说明：<span>当您进行新绑定、解绑、更换认证手机的操作时，在最后一步操作前均会有操作后VIP信息如何转移的提醒，烦请您仔细查看后再点击确定，避免误操作。</span></p>
								
								<div className="answer">Q：什么是心享俱乐部体验会员？</div>
								<div className="response">
									
									<p><strong>A:</strong>心享俱乐部体验会员:近6个自然月满足消耗指定金额的会员玩家，每月1日可直升至白金或钻石会员，并提供专属客户经理服务 
								  	。白金体验会员享受大客户经理服务；钻石体验会员享受高级客户经理服务</p>
								   	  <p className="set-margin">（http://vip.sdo.com/v/index.html）。</p>
           							
								</div>
								<div className="answer">Q：如何获得心享俱乐部白金体验会员？</div>
								<div className="response">
									
									<p><strong>A:</strong>“白金会员体验特权”获取方式：</p>
								   	  <p >1）单个通行证账号会员等级为黄金会员及以下，满足近6个月消耗金额达到1万元（即在指定游戏应用内消费的元宝、点券等）,该账号对应绑定手机升级为“白金体验会员”；
						            例如今年6月获得白金会员体验权，需在去年12月至今年5月消耗金额达到1万元；</p>
						           	<p> 2）成为传奇悦享会闪耀传奇或璀璨传奇会员，且通行证账号会员等级为黄金会员及以下；</p>
						           	<p>3）成为心享俱乐部游戏特权会员，且通行证账号会员等级为黄金会员及以下；</p>
						           	<p>4）钻石会员赠予：钻石会员每月享有1次赠予权利，可指定任意一个用户升级为白金体验会员；赠予的白金体验会员，有效期为1个月（从赠予当天开始计算）。</p>
									
									<div className="answer">Q：如何获得心享俱乐部钻石体验会员？</div>
									<p><strong>A:</strong>“钻石会员体验特权”获取方式：</p>
									<p>1）单个通行证账号会员等级为白金会员及以下，满足近6个月消耗金额达到10万元（即在指定游戏应用内消费的元宝、点券等）,该账号对应绑定手机升级为“钻石体验会员”； 
						            例如6月获得钻石会员体验权，需在12月至5月消耗金额达到10万元；</p>
						            <p>2） 成为传奇悦享会至尊传奇会员，且通行证账号会员等级为白金会员及以下；</p>
						            <p> 3）成为心享俱乐部游戏特权最高等级会员，且通行证账号会员等级为白金会员及以下。</p>
								</div>
								<div className="answer">Q：心享俱乐部体验会员升级时间？</div>
								<div className="response">
									
									<p><strong>A:</strong>心享俱乐部VIP体验会员升级时间：<span>每月1日更新</span>，升级为体验会员，账号的认证手机会收到升级短信通知。</p>
									<div className="answer">Q：心享俱乐部体验会员有效期是多久？</div>
									<p><strong>A:</strong>体验权有效期：心享俱乐部体验会员有效期为1个月，待有效期结束后，如单个通行证账 
							          号仍满足条件，则延长体验权1个月；如不满足，则恢复为当前成长值对应的会员等级，体验权失效以后， 账号的认证手机会收到降级短信通知。</p>
								</div>
								<div className="answer">Q：新绑定、解绑、更换认证手机时心享俱乐部体验会员怎么处理？</div>
								<div className="response">
									
									<p><strong>A:</strong>进行新绑定、解绑操作的账号时必须满足：在心享俱乐部体验会员有效期内。</p>
									<p>  1）解绑、更换、群更换：当通行证账号发生以下操作，解绑、更换、群更换认证手机时，原账号对应的认证手机保留心享俱乐部体验会员等级；</p>
           							<p>2） 新绑：游戏通行证账号发生新绑操作，<span>如该账号升级为心享俱乐部体验会员时为独立账号（未绑定认证手机），则该账号新绑定认证手机继承体验会员等级。</span></p>
								</div>
	
							</div>
						</div>
                                                                                     
					</div>
					<LeftNav 
						myTitle="个人中心"						
						optData={["left-nav-active","","my-message-btn"]}
						childData={["我的会员","我的福利","我的消息"]}
					>
					
					</LeftNav>

				</div>
			</div>
		

			

		)
  	}
}

export default MyMember


// WEBPACK FOOTER //
// ./src/container/my-member/my-member.js